
























import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component
export default class DlgPostsDelete extends Vue {
  @Prop({type: Object, default: null}) private post!: any;

  private loading: boolean = false;
  private dialog: boolean = false;

  @Action('moderator/posts/del') private postDel!: any;
  @Action('moderator/posts/read') private postRead!: any;

  private del() {
    this.loading = true;
    this.postDel(this.post).then((res) => {
      this.loading = false;
      if (res) {
        this.postRead();
        this.dialog = false;
      }
    });
  }
}
// // import { VueEditor } from 'vue2-editor';
// import { mapActions } from 'vuex';
//
//
// export default {
//   name: 'DlgMemberDelete',
//   components: {
//     // VueEditor,
//   },
//   data() {
//     return {
//       dialog: false,
//       loading: false,
//     };
//   },
//   props: ['member'],
//   methods: {
//     ...mapActions({
//       memberDel: 'members/del',
//       memberRead: 'members/read',
//     }),
//     del() {
//       this.loading = true;
//       this.memberDel(this.member).then((res) => {
//         this.loading = false;
//         if (res) {
//           this.memberRead();
//           this.dialog = false;
//         }
//       });
//     },
//   },
// };
